import { Queue } from 'lib-shared-legacy-types';

import { ajaxSend } from '../../../../api/api';

// Get queue by id
export function transferToQueueRequest(payload: {
  csid: number;
  requestToQueue: Queue;
  message: string;
}) {
  const { csid, requestToQueue } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${csid}/transfer/queue`,
    data: {
      queue_id: requestToQueue.id,
    },
  });
}
